import { useIsFetching } from "@tanstack/react-query";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { useCheckPart } from "#modules/similarPart/view/useCheckPart";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { isJobProcessing } from "shared";

export const useUnavailableMaterialVolume = ({
  volume,
  part,
  quoteRequestLineId,
}: {
  volume: number | null | undefined;
  part: PartDto | undefined;
  quoteRequestLineId: string;
}) => {
  const isFetchingQrl = useIsFetching({
    queryKey: queryKeys.quoteRequestLines.detail(quoteRequestLineId),
  });

  const isPartBeingAnalyzed = part?.analyzeStatus ? isJobProcessing(part.analyzeStatus) : false;

  const { checkPart, isPending: isLoading } = useCheckPart();

  const onRelaunchAnalyze = () => {
    if (!part) {
      return;
    }
    checkPart({
      id: part.id,
      force: true,
      shouldPredictAfterAnalyze: true,
      quoteRequestLineId,
    });
  };

  return {
    displayWarning: volume === null || volume === undefined,
    isLoading: isPartBeingAnalyzed || isLoading || isFetchingQrl,
    onRelaunchAnalyze,
  };
};
